import { normalizeKey } from '@deity-io/di-data-basics';
import { META_KEY } from 'contracts/constants';
import * as _ from 'lodash';
import type { ISchemaState, ISourceModel } from './SchemaContext';

export class SchemaContextHelper {
  /* eslint-disable-next-line no-empty-function */
  constructor(readonly state: ISchemaState) {}

  getSelectedFieldInfo = (): {
    name: string;
    path: Array<string>;
    fieldJson: Record<string, any>;
    settings: Record<string, any>;
    isContainer: boolean;
    isLookupSource: boolean; // selected schema is not the same as the current schema
    isLink: boolean; // is the first node of a reduced schema
    settingsPath: Array<string>;
    source?: ISourceModel;
  } | void => {
    if (this.state && this.state.schema && this.state.selectedField) {
      const isLookupSource = this.state.selectedSchema && this.state.selectedSchema.uuid !== this.state.uuid;
      const json = isLookupSource ? this.state.selectedSchema!.schema : this.state.schema;
      // remainder of the path. in the selected schema
      const path = [...this.state.selectedField].slice(this.state?.selectedSchema?.path?.length || 0);
      const isLink = this.state?.selectedSchema?.link !== undefined;

      const field = path.length ? _.get(json, path) : json;
      let name: string;
      if (path.length) {
        name = path.pop() as string;
      } else if (isLink && this.state.selectedField.length && this.state?.selectedSchema?.path) {
        name = [...this.state.selectedSchema.path].pop() as string;
      } else if (META_KEY in field) {
        if ('name' in field[META_KEY]) {
          name = field[META_KEY].name as string;
        } else {
          name = normalizeKey(this.state.name);
        }
      } else if ('name' in field) {
        name = field.name as string;
      } else {
        name = normalizeKey(this.state.name);
      }

      if (field) {
        const isContainer = META_KEY in field;

        return {
          name,
          path: [...this.state.selectedField],
          fieldJson: field,
          isContainer,
          isLink: isLink || false,
          isLookupSource: isLookupSource || false,
          settings: isContainer ? field[META_KEY] : field,
          settingsPath: (isContainer ? [...this.state.selectedField, META_KEY] : this.state.selectedField).slice(
            this.state?.selectedSchema?.path?.length || 0
          ),
          source: this.state.selectedSchema || undefined
        };
      }
    }
  };
}
